import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  locked: false,
  lockedReason: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      state.locked = false;
      state.lockedReason = null;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    setLocked: (state, action) => {
      state.locked = action.payload.locked;
      state.lockedReason = action.payload.reason;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
    },

    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.locked = false;
      state.lockedReason = null;
      
      // state = {
      //   user: null,
      //   isAuthenticated: false,
      //   loading: false,
      //   error: null,
      //   locked: false,
      //   lockedReason: null,
      // }
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      // redirect to login
      window.location.href= '/auth/sign-in'
    },
  },
});

export const { setUser, setLoading, setError, logout, setLocked, updateUser } = authSlice.actions;

export default authSlice.reducer;
